import React, { useMemo, useState } from 'react';
import { ChevronDown, Lightbulb, ThumbsUp } from 'lucide-react';

const STOP = new Set('the and for are but not you your with this that have has was were can cant how what why when where who which does did doesnt dont from into about there their they them then than just get got its it\'s will would could should been being help need please thanks thank hello want also any some more very really still my me our out on in of to is am an at be by do if or so up'.split(' '));
const stem = (w) => w.replace(/(ing|ed|es|s)$/, '').slice(0, 6);
const words = (t) => [...new Set((t.toLowerCase().match(/[a-z0-9']+/g) || []).map((w) => w.replace(/'/g, '')).filter((w) => w.length > 2 && !STOP.has(w)).map(stem))];

export const matchFaqs = (faqs, text, limit = 3) => {
  const terms = words(text);
  if (!terms.length) return [];
  return faqs.map((f) => {
    const q = new Set(words(f.question));
    const a = new Set(words(f.answer));
    const hitsQ = terms.filter((t) => q.has(t)).length;
    return { f, hitsQ, score: hitsQ * 2 + terms.filter((t) => a.has(t)).length };
  }).filter((x) => x.hitsQ > 0 || x.score >= 2).sort((x, y) => y.score - x.score).slice(0, limit).map((x) => x.f);
};

export const HcFaqSuggestions = ({ faqs, text, onSolved }) => {
  const [openId, setOpenId] = useState(null);
  const matches = useMemo(() => matchFaqs(faqs, text), [faqs, text]);
  if (!matches.length) return null;
  return (
    <div className="rounded-xl border border-[#922A8C]/20 bg-[#F6EAF5]/60 p-3 hc-fade-up" data-testid="hc-faq-suggestions">
      <div className="flex items-center gap-2 text-sm font-semibold text-[#922A8C] mb-2"><Lightbulb className="w-4 h-4" />These answers might help</div>
      <ul className="space-y-2">
        {matches.map((f) => (
          <li key={f.id} className="bg-white rounded-lg border border-gray-100" data-testid={`hc-faq-suggestion-${f.id}`}>
            <button type="button" onClick={() => setOpenId(openId === f.id ? null : f.id)} className="w-full flex items-center justify-between gap-3 text-left px-3 py-2 text-sm font-medium text-[#363636] hover:bg-gray-50 rounded-lg transition-colors" aria-expanded={openId === f.id} data-testid={`hc-faq-suggestion-toggle-${f.id}`}>
              {f.question}<ChevronDown className={`w-4 h-4 shrink-0 text-[#922A8C] transition-transform ${openId === f.id ? 'rotate-180' : ''}`} />
            </button>
            {openId === f.id && (
              <div className="px-3 pb-3">
                <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed" data-testid={`hc-faq-suggestion-answer-${f.id}`}>{f.answer}</p>
                <button type="button" onClick={() => onSolved(f)} className="mt-2 inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-[#922A8C] text-white text-xs font-semibold hover:bg-[#7a2275] transition-colors" data-testid={`hc-faq-suggestion-solved-${f.id}`}>
                  <ThumbsUp className="w-3.5 h-3.5" />This solved it
                </button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
